import context from '@helpers/context'

const [SalonSectionContext, useSalonSectionContext] = context<Customer.Contexts.SalonSection>()

export default SalonSectionContext
export { useSalonSectionContext }